const muiInsertComment = document.createComment("mui-jss-insertion-point")
document.head.appendChild(muiInsertComment)

const tpInsertComment = document.createComment("token-portal-insertion-point")
document.head.appendChild(tpInsertComment)
